import React from 'react';
import { List, ListItemProps } from 'semantic-ui-react';

import config from '@config/config';
import { styled } from '@modules/common/components/ThemeProvider/utils';

export const SidebarItemWrapper = styled(List.Item)<ListItemProps & { disabled?: boolean }>`
  background: ${props => (props.active ? config.selectedSidebarItemBackground : 'inherit')};
  padding: 0px !important;
  min-width: 100%;

  &:hover {
    background: #fff !important;
  }
`;
